<template>
  <div class="footer-wrapper">
    <div class="footer">
      <div class="top">
        <img class="company-name" src="//img.souche.com/f2e/609777196ef17b34f599e2eb9ea78960.svg" />
        <div class="phone">{{ $t("tel") }}0571-88607326</div>
      </div>
      <div class="content">
        <div class="col col1">
          <div class="divider"></div>
          <nuxt-link to="/html/about-us/" class="group-title">{{ $t("关于我们") }}</nuxt-link>
          <nuxt-link :to="`/html/about-us/#${$i18Id($t('发展历程'))}`" class="group-item">{{ $t("发展历程") }}</nuxt-link>
          <nuxt-link :to="`/html/about-us/#${$i18Id($t('投资人背景'))}`" class="group-item">{{ $t("投资人背景") }}</nuxt-link>
        </div>
        <div class="col col2">
          <div class="divider"></div>
          <nuxt-link to="/html/products/" class="group-title">{{ $t("主营业务") }}</nuxt-link>
          <nuxt-link :to="`/html/products/#${$i18Id($t('重点业务'))}`" class="group-item">{{ $t("重点业务") }}</nuxt-link>
          <nuxt-link :to="`/html/products/#${$i18Id($t('服务矩阵'))}`" class="group-item">{{ $t("服务矩阵") }}</nuxt-link>
        </div>
        <div class="col col2">
          <div class="divider"></div>
          <nuxt-link to="/html/news/" class="group-title">{{ $t("公司动态") }}</nuxt-link>
          <nuxt-link :to="`/html/news/#${$i18Id($t('最新动态'))}`" class="group-item">{{ $t("最新动态") }}</nuxt-link>
          <nuxt-link :to="`/html/news/#${$i18Id($t('数据报告'))}`" class="group-item">{{ $t("数据报告") }}</nuxt-link>
          <nuxt-link :to="`/html/news/#${$i18Id($t('媒体资料'))}`" class="group-item">{{ $t("媒体资料") }}</nuxt-link>
        </div>
        <div class="col col3">
          <div class="divider"></div>
          <nuxt-link to="/html/contact-us/" class="group-title">{{ $t("联系我们") }}</nuxt-link>
          <nuxt-link :to="`/html/contact-us/#${$i18Id($t('主要办公地点'))}`" class="group-item">{{ $t("主要办公地点") }}</nuxt-link>
          <nuxt-link :to="`/html/contact-us/#${$i18Id($t('合作洽谈'))}`" class="group-item">{{ $t("合作洽谈") }}</nuxt-link>
          <nuxt-link :to="`/html/contact-us/#${$i18Id($t('廉政合规'))}`" class="group-item">{{ $t("廉政合规") }}</nuxt-link>
          <nuxt-link :to="`/html/contact-us/#${$i18Id($t('加入我们'))}`" class="group-item">{{ $t("加入我们") }}</nuxt-link>
        </div>
        <!-- <div class="col">
        <img :src="$t('qr')" class="qrcode" />
      </div> -->
      </div>
      <div class="contact">{{ $t("tel") }}<a href="tel:0571-88607326">0571-88607326</a></div>
      <div class="copy-right">
        {{ c.Copyright || "Copyright©杭州大搜车汽车服务有限公司" }}
        <a href="https://beian.miit.gov.cn" target="_blank">{{ c.bei || "浙ICP备16047798号-8" }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      zh: {
        tel: "联系电话：",
        copyright: "Copyright©浙江大风车科技有限公司",
        icp: "浙ICP备2023041146号-1",
        关于我们: "关于我们",
        投资人背景: "投资人背景",
        发展历程: "发展历程",
        主营业务: "主营业务",
        重点业务: "重点业务",
        服务矩阵: "服务矩阵",
        联系我们: "联系我们",
        主要办公地点: "主要办公地点",
        合作洽谈: "合作洽谈",
        廉政合规: "廉政合规",
        加入我们: "加入我们",
        公司动态: "公司动态",
        最新动态: "最新动态",
        数据报告: "数据报告",
        媒体资料: "媒体资料",
        qr: "//img.souche.com/f2e/4e2b2fbb3fa3cfd3f4a4f2d3d6e67797.png",
      },
      en: {
        tel: "Contact: ",
        copyright: "Copyright © Zhejiang DaFengChe Technology Co., Ltd.",
        icp: "ICP License Number: 2023041146-1",
        关于我们: "About Us",
        投资人背景: "Investor List",
        发展历程: "Company History",
        主营业务: "Business",
        重点业务: "Key Businesses",
        服务矩阵: "Service Offerings",
        联系我们: "Contact Us",
        主要办公地点: "Offices",
        合作洽谈: "Contacts",
        廉政合规: "Integrity & Compliance",
        加入我们: "Join Us",
        公司动态: "News",
        最新动态: "News & Events",
        数据报告: "Industry & Reports",
        媒体资料: "Media Library",
        qr: "//img.souche.com/f2e/4292380c4fe1ade40777754a7cb89156.png",
      },
    },
  },
  computed: {
    c() {
      if (
        process.client &&
        (location.hostname === "www.dasouche.com" ||
          location.hostname === "www.souche.com" ||
          location.hostname === "new.souche.com" ||
          location.hostname === "localhost" ||
          location.hostname === "f2e.prepub.souche.com" ||
          location.hostname === "f2e.souche.com")
      ) {
        return {
          Copyright: this.$t("copyright"),
          bei: this.$t("icp"),
        };
      }
      return {};
    },
  },
};
</script>

<style lang="less" scoped>
@import "../imported.less";
.footer-wrapper {
  background: linear-gradient(93.39deg, #333335 0%, #242426 100%);
}
.footer {
  margin: 0 auto;
  padding: 88px 120px 60px 120px;
  box-sizing: border-box;
  width: var(--min-content-width);
}

.top {
  .company-name {
    width: 140px;
    height: 37px;
    display: block;
    fill: rebeccapurple;
  }

  .phone {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    color: #ffffff;
    margin: 18px 0 0 0;
    white-space: pre;
  }
}

.copy-right {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin-top: 50px;
  a {
    color: #ffffff;
    text-decoration: none;
  }
}

.content {
  display: flex;
  overflow: hidden;
  margin-top: 66px;

  // .qrcode {
  //   width: 120px;
  //   height: 158px;
  // }

  .group-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #ff571a;
    text-decoration: none;
    margin-top: 24px;
    text-transform: capitalize;
  }

  .group-item {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    margin-top: 16px;
    text-decoration: none;
    text-transform: capitalize;
  }

  .divider {
    position: relative;
    width: 100%;
    height: 1px;
    flex-shrink: 0;

    &::after {
      content: "";
      width: 200%;
      height: 200%;
      position: absolute;
      top: 0;
      left: 0;
      border-top: 1px solid #ff571a;
      border-radius: 2px;
      -webkit-transform: scale(0.5, 0.5);
      transform: scale(0.5, 0.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
    }
  }
  .col {
    flex: 1;
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;

    &:not(:first-child) {
      margin-left: 90px;
    }
  }
}

.contact {
  display: none;
}

@media screen and (max-width: 540px) {
  .footer-wrapper {
    background: #f7f8fa;
    padding: 20px 0;
  }
  .footer {
    padding: 0;
    box-sizing: border-box;
  }

  .top {
    display: none;
  }

  .contact {
    display: block;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    color: #5e5e66;
    text-align: center;
    a {
      color: #5e5e66;
      text-decoration: none;
    }
  }
  .copy-right {
    font-weight: 300;
    font-size: 9px;
    line-height: unset;
    text-align: center;
    margin: 7px 7px 0 7px;
    color: #5e5e66;
    a {
      color: #5e5e66;
    }
  }

  .content {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyFooter.vue